// WebAuthn browser helpers: base64url ↔ ArrayBuffer conversions and platform detection

export const b64urlToBuf = (str) => {
  const pad = str.length % 4 === 0 ? 0 : 4 - (str.length % 4);
  const b64 = (str + "=".repeat(pad)).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const buf = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) buf[i] = raw.charCodeAt(i);
  return buf.buffer;
};

export const bufToB64url = (buf) => {
  const bytes = new Uint8Array(buf);
  let str = "";
  for (let i = 0; i < bytes.length; i++) str += String.fromCharCode(bytes[i]);
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const webAuthnSupported = () =>
  typeof window !== "undefined" && !!window.PublicKeyCredential && !!navigator.credentials?.create;

export const platformBiometricAvailable = async () => {
  if (!webAuthnSupported()) return false;
  try {
    return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  } catch { return false; }
};

// Serialize the browser credential to a JSON-safe object for the backend
const serializeCred = (cred, extraKeys = []) => {
  const out = {
    id: cred.id,
    rawId: bufToB64url(cred.rawId),
    type: cred.type,
    response: {},
    clientExtensionResults: cred.getClientExtensionResults?.() || {},
    authenticatorAttachment: cred.authenticatorAttachment || undefined,
  };
  for (const k of extraKeys) {
    const v = cred.response?.[k];
    if (v) out.response[k] = bufToB64url(v);
    else if (v === null) out.response[k] = null;
  }
  return out;
};

// Register a platform authenticator (Face ID / Touch ID / Android biometric)
export const registerBiometric = async (optionsFromServer, deviceLabel) => {
  const publicKey = {
    ...optionsFromServer,
    challenge: b64urlToBuf(optionsFromServer.challenge),
    user: { ...optionsFromServer.user, id: b64urlToBuf(optionsFromServer.user.id) },
    excludeCredentials: (optionsFromServer.excludeCredentials || []).map((c) => ({ ...c, id: b64urlToBuf(c.id) })),
  };
  const cred = await navigator.credentials.create({ publicKey });
  if (!cred) throw new Error("İptal edildi");
  const payload = serializeCred(cred, ["clientDataJSON", "attestationObject"]);
  payload.device_label = deviceLabel || navigator.userAgent.slice(0, 60);
  return payload;
};

export const authenticateBiometric = async (optionsFromServer, email) => {
  const publicKey = {
    ...optionsFromServer,
    challenge: b64urlToBuf(optionsFromServer.challenge),
    allowCredentials: (optionsFromServer.allowCredentials || []).map((c) => ({ ...c, id: b64urlToBuf(c.id) })),
  };
  const cred = await navigator.credentials.get({ publicKey });
  if (!cred) throw new Error("İptal edildi");
  const p = serializeCred(cred, ["clientDataJSON", "authenticatorData", "signature", "userHandle"]);
  p.email = email;
  return p;
};
